export default [
  {
    path: "/",
    name: "管网调度",
    alias: ["/home"],
    component: () => import("@/views/home/Home.vue"),
    meta: {
      map: true,
      navigation: true,
      title:"江夏区城市运营信息调度中心"
    },
  },
  {
    path: "/leak",
    name: "漏损控制",
    component: () => import("@/views/leak/Index.vue"),
    meta: {
      map: true,
      navigation: true,
      title:"江夏区城市运营信息调度中心"
    },
  },
  {
    path: "/factory",
    name: "水厂调度",
    component: () => import("@/views/factory/Index.vue"),
    meta: {
      map: false,
      navigation: true,
      title:"江夏区城市运营信息调度中心"
    },
  },
  {
    path: "/sewage",
    name: "污水处理",
    component: () => import("@/views/sewage/Index.vue"),
    meta: {
      map: true,
      navigation: true,
      title:"江夏区城市运营信息调度中心"
    },
  },
  {
    path: "/process",
    name: "水厂工艺",
    component: () => import("@/views/process/Process.vue"),
    meta: {
      map: false,
      navigation: false,
      hideContainer: true,
    },
  },
];
